


























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import starRate from "@/components/starRate.vue";
@Component({ components: { starRate } })
export default class Logout extends Vue {
  public footerReply = "";
  public reply = "";
  public page = 1;
  public id: any = "";

  @Prop({
    default() {
      return [];
    },
    type: Array,
  })
  public list;
  //   public list = [
  //     {
  //       add_times: 1608529863,
  //       box_game_id: 1,
  //       comment_num: 0,
  //       comment_type: 0,
  //       content: "66666666666666",
  //       head_portrait: "http://static.dhsf.xqhuyu.com/box_test/head_img/head.png",
  //       id: 71,
  //       is_praise: 0,
  //       play_game_time: 0,
  //       praise_count: 1,
  //       stars_score: 5,
  //       uid: 1262900,
  //       user_name: "不服来战我贼吊",
  //       replyData: {
  //         data: [
  //           {
  //             comment_id: 51,
  //             content: "李得亏自信",
  //             head_portrait:
  //               "http://static.dhsf.xqhuyu.com/box_test/head_img/head.png",
  //             id: 400,
  //             is_praise: 0,
  //             praise_count: 0,
  //             time: 1608281467,
  //             to_uid: 1263381,
  //             to_user_name: "996hezi",
  //             uid: 1263077,
  //             user_name: "你牛酷睿",
  //           },
  //         ],
  //       },
  //     },
  //   ];

  // 去主页
  public toUserPage(id) {
    if (id == this.$store.state.user.info.id) {
      this.$fn.toRoute("/user");
    } else {
      this.$fn.toOtherUser(id);
    }
  }
  // 评价点赞
  public commentPraise(praise, ids) {
    this.$emit("commentPraise", { is_praise: praise, id: ids });
  }
  // 展示评价回复
  public handleShowReply(ids) {
    this.id = ids;
    this.$emit("handleShowReply", { id: ids, page: 1 });
  }
  // 评价中回复点赞
  public replyPraise(praise, itemIds, imIds) {
    this.$emit("replyPraise", {
      is_praise: praise,
      itemId: itemIds,
      imId: imIds,
    });
  }
  // 展示回复输入框
  public handleShowReplyInp(itemIds, imIds) {
    this.reply = "";
    this.$emit("handleShowReplyInp", { itemId: itemIds, imId: imIds });
  }
  // 发送回复
  public handleSendReply(types, ids, items) {
    this.$emit("handleSendReply", {
      type: types,
      id: ids,
      item: items,
      replyContent: types == 1 ? this.footerReply : this.reply,
    });
  }
  // 删除评价
  public delComment(id) {
    this.$emit("delComment", id);
  }
  // 删除回复
  public delReply(imIds, itemIds) {
    this.$emit("delReply", { imId: imIds, itemId: itemIds });
  }
  // 页码改变
  public changePage(i) {
    this.page = i;
    this.$emit("ReplyChangePage", { id: this.id, page: i });
  }
}
